import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import questionnaireRouter from './questionnaireRouter'
import reportRouter from './report'

Vue.use(VueRouter)

// 解决导航栏中的vue-router重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    redirect: '/questionnaire',
  },
  questionnaireRouter,
  ...reportRouter,
  {
    path: '/test',
    name: 'Test',
    component: () =>
      import(/* webpackChunkName: "report" */ '../layout/test.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
})

export default router
